/**
 * Error code constants.
 * Pattern: error.{category}.{subcategory}.{specific_error}
 */

import { ApiErrorCode } from './api';
import { CheckoutErrorCode } from './checkout';
import { PaynowErrorCode } from './paynow';
import { PortalErrorCode } from './portal';
import { GiftErrorCode } from './gift';
import { VoucherErrorCode } from './voucher';
import { PaymentErrorCode } from './payment';
import { AuthErrorCode } from './auth';
import { UiErrorCode } from './ui';
import { VueErrorCode } from './vue';
import { DebugCode } from './debug';

export { ApiErrorCode, CheckoutErrorCode, PaynowErrorCode, PortalErrorCode, GiftErrorCode, VoucherErrorCode, PaymentErrorCode, AuthErrorCode, UiErrorCode, VueErrorCode, DebugCode };
export { AuthLoginMode } from './auth';

/** Union of all error code values (for typed validation). */
export type ErrorCode =
  | ApiErrorCode
  | CheckoutErrorCode
  | PaynowErrorCode
  | PortalErrorCode
  | GiftErrorCode
  | VoucherErrorCode
  | PaymentErrorCode
  | AuthErrorCode
  | UiErrorCode
  | VueErrorCode;

const ALL_ERROR_CODES_SET = new Set<string>([
  ...Object.values(ApiErrorCode),
  ...Object.values(CheckoutErrorCode),
  ...Object.values(PaynowErrorCode),
  ...Object.values(PortalErrorCode),
  ...Object.values(GiftErrorCode),
  ...Object.values(VoucherErrorCode),
  ...Object.values(PaymentErrorCode),
  ...Object.values(AuthErrorCode),
  ...Object.values(UiErrorCode),
  ...Object.values(VueErrorCode),
]);

/**
 * @param code
 * @returns true if code is a known error code
 */
export function isValidErrorCode(code: string): code is ErrorCode {
  return ALL_ERROR_CODES_SET.has(code);
}
